import React from "react";
import style from "./contact.module.scss";
import { motion } from "framer-motion";
const ContactUsUI = () => {
  return (
    <>
      <motion.div
        className={style.container}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -20, opacity: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h1>Want To Get to Know Us? Let’s Cut the Distance</h1>

        <a href="mailto:info@texhnext.com">info@texhnext.com</a>

        <p>or</p>

        <h5>
          Hello, My name is <input type="text" placeholder="insert name" /> from{" "}
          <input type="text" placeholder="insert company name" />, I am looking
          for <input type="text" placeholder="insert service" />. Would love to
          Discuss it with you and I can be reached on{" "}
          <input type="text" placeholder="insert email address" />.
        </h5>
        <button>SUBMIT</button>
      </motion.div>
    </>
  );
};

export { ContactUsUI };
